import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

import {ErrorService, EventService, StatusResponse} from '..';

import {ConfigService} from './config.service';


@Injectable({providedIn: 'root'})
export class DemoService {
    private baseURL = ConfigService.getApiEndpoint() + 'v1/demo/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    generateDemoData(): Observable<StatusResponse> {
        return this.http.post<StatusResponse>(this.baseURL + 'generatedata', {}).pipe(
            tap(_ => this.eventService.addAlert('generated demo data')),
            catchError(this.error.handleError('generate demo data', null))
        );
    }

}
